<template>
  <v-container fluid>
    <v-row>
      <!-- CompanyCode -->
      <v-col cols="6" sm="3" md="2">
        <v-text-field v-model="cliente.companyCode" dense readonly hide-details label="Codice Utente" outlined />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="6">
        <v-text-field v-model="cliente.ragioneSociale" hide-details dense label="Ragione Sociale"
          :readonly="readonly" clearable />
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field v-model="cliente.indirizzo" dense hide-details label="Indirizzo" :readonly="readonly"
          clearable />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="6">
        <v-text-field v-model="cliente.eMail" dense hide-details label="E-mail" :readonly="readonly" clearable />
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field v-model="cliente.pIva" dense hide-details label="P.iva" :readonly="readonly" clearable />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="6">
        <v-text-field v-model="cliente.telefono" hide-details label="Telefono/Cellulare" :readonly="readonly" dense
          clearable />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="6">
        <v-text-field v-model="cliente.attivita" hide-details label="Attività" :readonly="readonly" dense
          clearable />
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field v-model="cliente.produttoreTrader" dense hide-details label="Produttore/Trader"
          :readonly="readonly" clearable />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "DatiUtente",

  props: {
    cliente: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
